import React from 'react';
import { reportClientError } from '../../services/onboardingTelemetry';

// A render crash in setup otherwise blanks the page for the customer and
// leaves nothing in any log: React handles it in the browser, and the server
// never hears about it. Report it and give them a way back in.
class SetupErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    reportClientError(error, {
      kind: 'render',
      component_stack: String(info?.componentStack || '').trim().split('\n').slice(0, 4).join(' | '),
    });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="mx-auto mt-16 max-w-md rounded-2xl border border-red-200 bg-white p-6 text-center shadow-sm">
        <h1 className="text-lg font-bold text-gray-950">Setup hit a problem</h1>
        <p className="mt-2 text-sm leading-6 text-gray-700">
          Anything you already saved is kept. Reload to carry on from where you were.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-4 min-h-[44px] rounded-lg bg-blue-700 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-800"
        >
          Reload setup
        </button>
      </div>
    );
  }
}

export default SetupErrorBoundary;
